export const APPOINTMENT_BOOKING_DESCRIPTIONS = {
  FIVE_MINS: [
    `To ensure that your chosen option works for you, and for verification purposes, you'll need to attend a short video check-in appointment with one of our doctors that will last up to 5 minutes. This is free of charge, and is required by health regulation`,
    `As long as you continue using Ease, you'll enjoy ongoing support from our care team.`,
    `Please checkout within 10 minutes from selection. Otherwise, your timeslot may be released.`,
  ],
  TEN_MINS: [
    'This video consultation costs $21.80 and lasts up to 10 minutes. Once you’ve selected your timeslot, please make sure to checkout within 10 minutes. Otherwise, your timeslot may be released.',
    `As long as you continue using Ease, you'll enjoy ongoing support from our care team.`,
  ],
  THIRTY_MINS: [
    `To ensure your chosen option works for you, and for verification purposes, our pharmacist will conduct a quick 2 min check-in over the phone during your chosen time window. This is free of charge and is required by health regulations.`,
    `As long as you continue using Ease, you'll enjoy ongoing support from our care team.`,
    `Please checkout within 10 minutes from selection. Otherwise, your timeslot may be released.`,
  ],
  STD_TESTING: [
    'After you have completed the checkout process, you will receive a text message with further details regarding your appointment.',
  ],
  BC_RENEWAL_12_MONTHS: [
    `As it has been 12 months or more since your last appointment with us, you'll need to attend a short video check-in appointment with one of our doctors to make sure you are doing fine with your birth control method.`,
    'This is free of charge, and is required by health regulations.',
  ],
};

export const APPOINTMENT_BOOKING_TYPE = {
  FIVE_MINS: '5',
  TEN_MINS: '10',
  THIRTY_MINS: '30',
  STD_TESTING: 'null',
  BC_RENEWAL_12_MONTHS: '0',
};

export const TIME_LIST = [
  {
    label: '10:00 AM',
    value: '2021-12-23T13:02:00.000Z',
  },
  {
    label: '10:00 AM',
    value: '2021-12-22T00:55:36.658Z',
  },
  {
    label: '10:00 AM',
    value: '2021-12-23T17:01:00.000Z',
  },
  {
    label: '10:00 AM',
    value: '2021-12-23T17:00:00.000Z',
  },
  {
    label: '10:00 AM',
    value: '2021-12-23T17:04:00.000Z',
  },
  {
    label: '10:00 AM',
    value: '2021-12-23T17:05:00.000Z',
  },
  {
    label: '10:00 AM',
    value: '2021-12-23T17:07:00.000Z',
  },
  {
    label: '10:00 AM',
    value: '2021-12-23T17:08:00.000Z',
  },
];
